import { LanguageType, ResponseType } from '@/types';
import { get } from './baseAxios';
import { API_LANGUAGE } from './urls';

const getLanguages = (): Promise<ResponseType<LanguageType[]>> => get(API_LANGUAGE);

export { getLanguages };

